export enum ProductColor {
    Black = "black",
    White = "white",
    Rosa = "rosa",
  }
  